(function() {
  'use strict';

  var LABEL_BROWSE = '001 — BROWSE';
  var LABEL_CATEGORIES = '002 — CATEGORIES';
  var LABEL_PAGES = '003 — PAGES';

  function classifyItem(text) {
    var t = text.trim().toLowerCase();
    if (t === 'home' || t === 'shop') return 'browse';
    if (/cardigan|men|women|iconic|starsky|lebowski|dudeism|all/.test(t)) return 'category';
    return 'page';
  }

  function injectLabels() {
    var navList = document.querySelector('.menu-drawer__menu.has-submenu');
    if (!navList) return false;
    if (navList.dataset.dmkLabeled === '1') return true; // already done
    var items = navList.querySelectorAll(':scope > li');
    if (!items.length) return false;

    navList.dataset.dmkLabeled = '1';

    var lastSection = null;
    items.forEach(function(li) {
      var link = li.querySelector('.menu-drawer__menu-item--mainlist');
      if (!link) return;
      var text = link.textContent || '';
      var section = classifyItem(text);
      if (section !== lastSection) {
        var label = document.createElement('span');
        label.className = 'dmk-drawer-eyebrow';
        label.textContent = section === 'browse' ? LABEL_BROWSE
                          : section === 'category' ? LABEL_CATEGORIES
                          : LABEL_PAGES;
        li.parentNode.insertBefore(label, li);
        lastSection = section;
      }
    });
    return true;
  }

  function watch() {
    // Try inject on load
    if (injectLabels()) return;

    // Listen for drawer toggle (single, no mutation observer loop)
    document.querySelectorAll('#Details-menu-drawer-container, details[id*="menu-drawer"]').forEach(function(el) {
      el.addEventListener('toggle', function() {
        if (el.open) {
          // Try multiple times in case of async drawer render
          setTimeout(injectLabels, 50);
          setTimeout(injectLabels, 250);
          setTimeout(injectLabels, 800);
        }
      });
    });

    document.addEventListener('click', function(e) {
      var s = e.target.closest('summary, .header__icon--summary, [aria-controls*="menu-drawer"]');
      if (s) {
        setTimeout(injectLabels, 80);
        setTimeout(injectLabels, 350);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
